import { Injectable, NgZone, OnDestroy } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { fromEvent, merge, Subscription, timer } from 'rxjs';
import { throttleTime } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class InactivityService implements OnDestroy {

  // tiempo máximo sin actividad: 5 minutos
  private readonly TIEMPO_INACTIVIDAD_MS = 5 * 60 * 1000;
  // private readonly TIEMPO_INACTIVIDAD_MS = 10 * 1000;

  private actividadSub?: Subscription;
  private temporizadorSub?: Subscription;
  private navegacionSub?: Subscription;

  private iniciado = false;

  constructor(
    private router: Router,
    private ngZone: NgZone
  ) { }

  // inicio el detector de inactividad
  iniciarControlInactividad(): void {
    if (this.iniciado) {
      return;
    }

    this.iniciado = true;

    const eventosActividad = merge(
      fromEvent(document, 'mousemove'),
      fromEvent(document, 'mousedown'),
      fromEvent(document, 'keydown'),
      fromEvent(document, 'scroll'),
      fromEvent(document, 'touchstart'),
      fromEvent(document, 'click')
    );

    this.ngZone.runOutsideAngular(() => {
      this.actividadSub = eventosActividad
        .pipe(throttleTime(1000))
        .subscribe(() => {
          this.reiniciarTemporizador();
        });
    });

    this.navegacionSub = this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) this.reiniciarTemporizador();
    });
    this.reiniciarTemporizador();
  }

  // reinicio el tiempo cada vez que el usuario hace algo
  private reiniciarTemporizador(): void {
    this.temporizadorSub?.unsubscribe();

    const token = localStorage.getItem('token');

    if (!token) {
      return;
    }

    // si ya está en login o lock-screen, no activo el contador
    const urlActual = this.router.url || '';

    if (
      urlActual.includes('login') ||
      urlActual.includes('lock-screen') ||
      urlActual.includes('forgot-password') ||
      urlActual.includes('reset-password') ||
      urlActual.includes('email-verificado')
    ) {
      return;
    }

    this.temporizadorSub = timer(this.TIEMPO_INACTIVIDAD_MS).subscribe(() => {
      this.ngZone.run(() => {
        this.bloquearPorInactividad();
      });
    });
  }

  // bloqueo la pantalla por inactividad
  private bloquearPorInactividad(): void {
    this.temporizadorSub?.unsubscribe();

    if (!localStorage.getItem('token')) return;
    localStorage.setItem('sipe_locked', 'true');
    localStorage.setItem('sipe_locked_reason', 'inactivity');

    this.router.navigate(['/lock-screen'], { replaceUrl: true });
  }

  ngOnDestroy(): void {
    this.actividadSub?.unsubscribe();
    this.navegacionSub?.unsubscribe();
    this.temporizadorSub?.unsubscribe();
  }
}